<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <el-col :lg="8">
        <el-page-header
          title
          @back="$router.push({ name: 'orderservices' })"
          :content="'Detalhes da O.OS ' + os_id"
        />
      </el-col>
      <el-col :lg="8" style="display: flex; flex-direction: column">
        <span>
          Cliente: <strong>{{ orderService.customer.name }}</strong>
        </span>
        <span>
          solicitante: <strong>{{ orderService.requester }}</strong>
        </span>
      </el-col>
      <el-col :lg="8" style="display: flex; flex-direction: column">
        <span>
          Motorista Responsável: <strong>{{ orderService.driver.name }}</strong>
        </span>
        <span>
          Status: <strong>{{ orderService.status | formatStatus }}</strong>
        </span>
      </el-col>
    </div>

    <h5>Total por serviço:</h5>
    <div style="display: flex; margin-bottom: 15px">
      <el-card
        style="margin-left: 5px"
        v-for="item in countByServices"
        :key="item.name"
      >
        <span>
          <strong style="color: rgb(50, 50, 49)">
            {{ item.service }}
          </strong>
          : {{ item.total }}
        </span>
      </el-card>
    </div>

    <el-collapse>
      <el-collapse-item :title="'BUSCAR HISTÓRICO POR OBJETO'">
        <el-form style="display: flex; align-items: flex-end">
          <el-form-item label="Objeto">
            <el-input v-model="filterTag" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item style="text-align: right; margin-left: 5px">
            <el-button type="success" autofocus @click="filterByTag()"
              >PESQUISAR</el-button
            >
          </el-form-item>
        </el-form>
        <OsDetailsHistoryTable v-if="historyByTag" :history="historyByTag" />
      </el-collapse-item>

      <el-collapse-item
        :title="'OBJETOS MAIS ENVIOS: (' + preposts.length + ')'"
      >
        <OrderObjects
          v-on:historyChange="findHistory"
          v-on:osChange="findOs"
          :preposts="preposts"
          :os_id="+os_id"
          :orderStatus="orderService.status"
        />
      </el-collapse-item>

      <el-collapse-item
        v-if="externalPlp"
        :title="'OBJETOS PLP TERCEIROS: (' + externalPlp.tags.length + ')'"
      >
        <OrderExternalObjects
          v-on:historyChange="findHistory"
          v-on:osChange="findOs"
          :plpExternalData="externalPlp"
          :os_id="+os_id"
        />
      </el-collapse-item>

      <el-collapse-item :title="'HISTÓRICO'">
        <OsDetailsHistoryTable :history="history" />
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>
<script>
import { OrderServicesDetailsService } from "@/services/customers/order.services.details.service";
import { OrderServicesService } from "@/services/customers/order.services.services";
import { ExternalService } from "@/services/customers/external.services.js";
import OsDetailsHistoryTable from "./Components/OsDetailsHistoryTable.vue";
import OrderObjects from "./Components/OrderObjects.vue";
import OrderExternalObjects from "./Components/OrderExternalObjects.vue";

export default {
  name: "OrderServicesDetails",
  components: {
    OsDetailsHistoryTable,
    OrderObjects,
    OrderExternalObjects,
  },

  data() {
    return {
      os_id: undefined,
      orderService: undefined,
      preposts: [],
      history: [],
      filterTag: "",
      historyByTag: [],
      countByServices: [],
      externalPlp: null,
    };
  },

  methods: {
    filterByTag() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      OrderServicesDetailsService.findByTag(vm.filterTag)
        .then((response) => {
          vm.historyByTag = [];
          vm.historyByTag.push(...response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    findHistory() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      OrderServicesDetailsService.findbyOs(vm.os_id)
        .then((response) => {
          vm.history = [];
          vm.history.push(...response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    findOs() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      OrderServicesService.get(vm.os_id)
        .then((response) => {
          vm.orderService = response;
          vm.preposts = [];
          vm.preposts.push(...response.prepost);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    findExternalObjects() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.getByOrderId(vm.os_id)
        .then((response) => {
          console.log(response);
          this.externalPlp = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    countTotalByService() {
      OrderServicesService.countTotalByService({
        orders_ids: this.os_id,
      })
        .then((response) => {
          this.countByServices = null;
          this.countByServices = response;
        })
        .catch((error) => {
          this.$notify.error({
            title: "Erro",
            message: error,
          });
        });
    },

    formatServiceName(serviceName) {
      return serviceName
        .replace("CONTRATO", "")
        .replace("-", "")
        .replace("CTR", "");
    },
  },

  filters: {
    formatStatus(status) {
      const options = {
        ["1"]: "Aberta",
        ["2"]: "Impressa",
        ["3"]: "Encerrada",
        ["4"]: "Coletada",
        ["5"]: "Entregue Agencia",
      };

      return options[status];
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.os_id = this.$route.params.id;
      this.findHistory();
      this.findOs();
      this.countTotalByService();
      this.findExternalObjects();
    }
  },
};
</script>
